(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ObjectTestResultHistoryController', ObjectTestResultHistoryController);

    ObjectTestResultHistoryController.$inject = ['$scope', '$state', '$http', '$sce', 'ObjectTestResult', '$uibModal', 'ParseLinks', 'AlertService', 'pagingParams'];

    function ObjectTestResultHistoryController($scope, $state, $http, $sce, ObjectTestResult, $uibModal, ParseLinks, AlertService, pagingParams) {
        var vm = this;
        vm.tabObjects = [];
        vm.checkestensione = false;
        vm.objectTestHistory = [];
        vm.objectInTest = [];
        vm.page = 0;
        vm.pdf = "pdf";
        vm.csv = "csv";
        vm.obj = {
            objectTypeName: pagingParams.object,
            id: pagingParams.id
        };

        if (vm.obj.objectTypeName !== null && vm.obj.objectTypeName !== undefined) {
            ObjectTestResult.historyObjectTest({object: vm.obj.objectTypeName}).$promise.then(function (tests) {
                if (tests.length > 0) {
                    vm.objectTestHistory = [];
                    if(vm.obj.id != -1)
                    {
                        tests.forEach(function (test) {
                            vm.objectTestHistory.push(test.split("\.")[0]);
                        })
                    }
                    else{
                        tests.forEach(function (test) {
                            vm.objectTestHistory.push(test);
                        })
                    }

                }
            });
        }

        vm.openFilePdf = function (name) {
            var body = {fileName: name, type: "inline"};

            $http.post("api/object-test-pdf", body, {responseType: 'blob'}
            ).then(function (data) {
                vm.showPdfFile = $sce.trustAsResourceUrl(
                    URL.createObjectURL(
                        new Blob([data.data], {type: data.headers("Content-Type")})));
                $uibModal.open({
                    templateUrl: 'app/management/commands/showPdf.html',
                    controller: 'ShowPdfController',
                    controllerAs: 'vm',
                    size: 'md',
                    backdrop: 'static',
                    windowClass: 'app-modal-window',
                    resolve: {
                        content: function () {
                            return vm.showPdfFile;
                        }
                    }
                }).result.then(function () {
                    vm.showPdfFile = "";
                });
            });
        }

        vm.downloadFilePdf = function (name) {
            var body = {fileName: name, type: "attachment", estensione: ".pdf"};

            $http.post('api/object-test-pdf', body, { responseType: 'blob' }
            ).then(function(data) {
                var blob = new Blob([data.data], {type: data.headers("Content-Type")});
                var url = window.URL.createObjectURL(blob);
                var anchor = document.createElement("a");
                var contentDisposition = data.headers("Content-Disposition");
                anchor.download = contentDisposition.substring(contentDisposition.indexOf("=")+1);
                anchor.href = url;
                anchor.click();
            });
        }
        vm.downloadFilePdf1 = function (name) {
            var body = {fileName: name, type: "attachment", estensione: ".csv"};

            $http.post('api/object-test-pdf', body, { responseType: 'blob' }
            ).then(function(data) {
                var blob = new Blob([data.data], {type: data.headers("Content-Type")});
                var url = window.URL.createObjectURL(blob);
                var anchor = document.createElement("a");
                var contentDisposition = data.headers("Content-Disposition");
                anchor.download = contentDisposition.substring(contentDisposition.indexOf("=")+1);
                anchor.href = url;
                anchor.click();
            });
        }
        vm.checkFiletype = function (name){
            var estensione = name.split('.');
            estensione = estensione[estensione.length -1];
            console.log(estensione);
            if(estensione === "csv")
            {
                vm.checkestensione = true;
            }
            else
                vm.checkestensione = false;
        }
    }
})();
